import { FiArrowRight } from "react-icons/fi";
import { useInView } from "../../hooks/useInView";
import { siteConfig } from "../../config/site";
import checklistImg from "../../assets/how-it-works-page/Right Visual_ Checklist Paper Mockup.png";
import appImg from "../../assets/how-it-works-page/Right Visual_ Smartphone Loan Application Mockup.png";
import reviewCardImg from "../../assets/how-it-works-page/Right Visual_ 3D Frosted Review Card with Green Graphic.png";
import disbursedImg from "../../assets/how-it-works-page/Right Visual_ 3D Stage & Disbursed Card with Popper.png";

interface Step {
  number: string;
  title: string;
  description: string;
}

const STEPS: Step[] = [
  {
    number: "01",
    title: "Check Eligibility",
    description: "See which loan options you may qualify for.",
  },
  {
    number: "02",
    title: "Apply Online",
    description: "Fill out your application with the required details.",
  },
  {
    number: "03",
    title: "Get a Decision",
    description:
      "Your application is reviewed based on the applicable eligibility criteria.",
  },
  {
    number: "04",
    title: "Get Your Funds",
    description:
      "Once approved and the loan agreement is completed, funds are disbursed according to the applicable terms.",
  },
];

export function ProcessSteps() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-white px-4 py-10 sm:py-14">
      <div className="relative mx-auto flex w-full max-w-[1330px] flex-col items-center gap-6 overflow-hidden">
        <div
          ref={ref}
          className={`relative z-10 flex flex-col items-center gap-4 text-center ${inView ? "in-view" : ""}`}
        >
          <h2 className="reveal-scroll delay-1 max-w-[720px] text-3xl font-extrabold leading-tight text-[#1c1917] sm:text-4xl lg:text-5xl">
            A simple loan process in{" "}
            <span className="text-[#e67e22]">4 easy steps</span>.
          </h2>
        </div>

        <div className="relative z-10 grid w-full grid-cols-1 gap-5 sm:grid-cols-2">
          {STEPS.map((step, idx) => {
            let imgSrc: string;
            if (idx === 0) imgSrc = checklistImg;
            else if (idx === 1) imgSrc = appImg;
            else if (idx === 2) imgSrc = reviewCardImg;
            else imgSrc = disbursedImg;

            return (
              <div
                key={step.number}
                className="reveal-scroll flex flex-col items-stretch gap-4 rounded-[24px] bg-[#f9f7fc] p-6 sm:flex-row sm:min-h-[358px]"
                style={{ animationDelay: `${0.4 + idx * 0.1}s` }}
              >
                {/* Left: text content */}
                <div className="flex w-full flex-col sm:w-[45%] sm:shrink-0">
                  <span className="text-3xl font-bold leading-none text-[#d6d3e0]">
                    {step.number}.
                  </span>

                  <h3 className="pt-4 text-xl font-bold leading-tight text-[#1c1917]">
                    {step.title}
                  </h3>
                  <p className="pt-2 text-sm leading-6 text-[#64748b]">
                    {step.description}
                  </p>

                  <div className="mt-4 sm:mt-auto sm:pt-4">
                    <a
                      href={siteConfig.applyLink || undefined}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={step.title}
                      className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#1c1917] shadow-[0px_1px_2px_rgba(0,0,0,0.08)] transition-opacity hover:opacity-80"
                    >
                      <FiArrowRight className="h-4 w-4" />
                    </a>
                  </div>
                </div>

                {/* Right: illustration */}
                <div className="h-[220px] w-full overflow-hidden rounded-2xl sm:h-auto sm:w-[55%]">
                  <img
                    src={imgSrc}
                    alt={step.title}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
